import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromRoot from '../../reducers';
import * as newsActions from '../../actions/news.actions';
import { Post } from '../../interfaces';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'edge-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class PageNewsComponent implements OnInit {
  showNews = true;

  newsArticles$: Observable<Array<any>> = this.store.pipe(
    select(fromRoot.getNewsArticles)
  );
  newsArticles: Array<any>;

  constructor(private store: Store<fromRoot.State>) {}

  ngOnInit(): void {
    if (environment.production) {
      this.showNews = false;
    } else {
      this.store.dispatch(newsActions.GetNews());
      if (this.newsArticles$) {
        this.newsArticles$.subscribe(
          (articles) => (this.newsArticles = articles)
        );
      }
    }
  }
}
